import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DepartmentGroupForm from '../../../../components/masters/department/departmentGroup/DepartmentGroupForm';
import DepartmentGroupTable from '../../../../components/masters/department/departmentGroup/DepartmentGroupTable';
import { fetchDepartmentGroups, addDepartmentGroup, updateDepartmentGroup, deleteDepartmentGroup, setDepartmentGroupEdit, clearDepartmentGroupEdit } from '../../../../redux/actions/masters/department/departmentGroup/departmentGroupAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .department-group-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .department-group-form, .department-group-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const DepartmentGroupPage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingDepartmentGroup, formSuccess, formError } = useSelector(state => state.departmentGroup || {});
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchDepartmentGroups());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearDepartmentGroupEdit());
  };

  const handleSubmit = async (form) => {
    if (editingDepartmentGroup && editingDepartmentGroup.department_group_id) {
      await dispatch(updateDepartmentGroup(editingDepartmentGroup.department_group_id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addDepartmentGroup(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (departmentGroup) => {
    dispatch(setDepartmentGroupEdit(departmentGroup));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteDepartmentGroup(id));
  };

  const handleCancel = () => {
    dispatch(clearDepartmentGroupEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      dg => dg.department_group_code === code && (!excludeId || dg.department_group_id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="department-group-flex">
        <div style={tableContainer} className="department-group-table">
          <DepartmentGroupTable
            onNew={handleFormReset}
            departmentGroups={list}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="department-group-form">
          <DepartmentGroupForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingDepartmentGroup={editingDepartmentGroup}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default DepartmentGroupPage; 